import { GeometryPrimitive } from "@rhinov/savane-js";
import { EntityController } from "./EntityController";

export class GeometryPrimitiveEntityController extends EntityController {
    declare entity: GeometryPrimitive;

    constructor(entity: GeometryPrimitive, panel: any, deliverable: any) {
        super(entity, panel, deliverable);
    }
}